<script lang="ts">
	import type { Device } from 'src/types/Device';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import IRDeviceCodes from '../../IRDeviceCodes.svelte';
	import { getIRFirmwareId } from 'src/helpers/ir_controller_helpers';

	export let device: Device;
</script>

<DeviceViewStateWrapper {device}>
	<div slot="content">
		<IRDeviceCodes {device} irDeviceId={getIRFirmwareId(device.channel)} />
	</div>
</DeviceViewStateWrapper>
